// Window event the bulk export dispatches (export-subscriber.jsx) and the
// Notifications nav item listens for to show its hint. Shared so the two roots
// agree on the name.
export const SUBSCRIBER_EXPORT_REQUESTED_EVENT = "subscriber-export:requested"
